const state = {
  dayStats: {}
}

export default state
